import React from 'react';

import './CourseList.scss';
import sendEvent from '../../helpers/tracking';
import { isExternalLink } from '../../helpers/link';
import icons from '../../shared/assets/icons/redesign';

const { LoadMore } = icons;

export default function CourseList({ NextLink, showEmailPopup }) {
  const list = [{
    title: 'Zwangerschap',
    subtitle: 'Eva van hoorn',
    link: '/cursus/zwangerschapscursus/040verloskunde',
    imageUrl: '/courses/040verloskunde.png'
  }, {
    title: 'Bevalling',
    subtitle: '040 verloskundigen',
    imageUrl: '/courses/eva-van-hoorn.png',
    link: '/cursus/bevalcursus/eva-van-hoorn'
  }, {
    title: 'Borstvoeding',
    subtitle: 'Eva van hoorn',
    imageUrl: '/courses/nvl.png',
    link: '/cursus/borstvoedingscursus/nvl'
  }, {
    title: 'Sporten en bewegen',
    subtitle: 'Annelieke Janssen',
    imageUrl: '/courses/annelieke-janssen.png',
    link: '/cursus/sporten-en-bewegen/annelieke-janssen'
  }];

  return (
    <div className="courseList">
      <ul className="courseList-list">
        {list.map((item, idx) => {
          return (
            <NextLink href={item.link} key={idx}>
              <li
                className="courseList-list-item"
                onClick={() =>
                  sendEvent('course_lander', 'course_lander_bekijken', 'bekijken')}>

                <img
                  alt="course-image"
                  src={item.imageUrl}
                  className="courseList-list-item-image"
                />

                <h4 className="courseList-list-item-title">
                  {item.title}
                </h4>

                <h5 className="courseList-list-item-subtitle">
                  {item.subtitle}
                </h5>

                <button className="courseList-list-item-button">
                  Bekijken
                </button>
              </li>
            </NextLink>
          )
        })}
      </ul>

      <button
        onClick={() => (showEmailPopup(true),
          sendEvent('course_lander', 'course_lander_loadmore', 'loadmore'))}
        className="courseList-load-more-button">
        <LoadMore className="courseList-load-more-icon" />
        Laad meer
      </button>
    </div>
  );
}
